import { IconSparkles } from '@tabler/icons-react'
import { Box, Stack, SvgIcon, Typography } from '@mui/material'
import { useEffect, useRef } from 'react'
import type { Message } from '../api'
import { MessageBubble } from './MessageBubble'

interface Props {
  messages: Message[]
}

export const ChatMessages = ({ messages }: Props) => {
  const bottomRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
    // eslint-disable-next-line react-hooks-addons/no-unused-deps
  }, [messages])

  if (messages.length === 0) {
    return (
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1.5,
          p: 3,
          color: 'text.secondary',
        }}
      >
        <SvgIcon sx={{ fontSize: 40, color: (t) => t.palette.action.disabled }}>
          <IconSparkles stroke={1.5} />
        </SvgIcon>
        <Stack>
          <Typography variant="subtitle2" textAlign="center">
            Ask anything about your products, inventory, sales, or customers.
          </Typography>
          <Typography variant="caption" textAlign="center">
            Currently you can not ask stuff about Storyous or Shopify
          </Typography>
        </Stack>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: 'auto',
        p: 2,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {messages.map((msg) => (
        <MessageBubble key={msg.id} message={msg} />
      ))}
      <div ref={bottomRef} />
    </Box>
  )
}
